import loader1Anim from './loader.json';
import loader2Anim from './loader2.json';
import greenLoadingAnim from './greenLoading.json';

export const loader1 = loader1Anim;
export const loader2 = loader2Anim;
export const greenLoading = greenLoadingAnim;
